<script setup lang="ts">
interface ISettingsBaseContainer {
  title?: string;
  titleClass?: string;
  miniContainer?: boolean;
  stacked?: boolean;
}
const props = withDefaults(defineProps<ISettingsBaseContainer>(), {
  title: '',
  miniContainer: false,
  titleClass: null,
  stacked: false,
});
</script>
<template>
  <div
    class="text-base-priority"
    :class="{
      'sm:rounded-lg p-4 pt-3 w-full sm:max-w-[428px] sm:mx-auto bg-layer mb-4':
        props.miniContainer,
      'rounded-lg sm:py-1 mx-auto': !props.miniContainer,
      '!p-0': 'force-zero-padding' in $attrs,
      'bg-layer': !!stacked,
    }"
  >
    <div
      v-if="!!title"
      class="block font-bold"
      :class="
        props?.titleClass + (props.miniContainer ? ' mb-3' : ' my-2 md:hidden')
      "
    >
      {{ title }}
    </div>
    <slot />
  </div>
</template>
